import { Anchor, Group, Stack, Text } from "@mantine/core";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { Link } from "react-router-dom";
import { useAccountsStore } from "../../../../../../stores/ConfigStore";
import { useProfileStore } from "../../../../../../stores/UserStore";
import { useMemo } from "react";
import { getLimit } from "../../../../../../functions/utilFunctions";

const ArgumentsLinkedin = ({ item, isCompleted }) => {
  const lang = useLanguage((s) => s.language);
  const accounts = useAccountsStore((s) => s.linkedin_accounts);
  const profile = useProfileStore((s) => s.profile);

  const account = useMemo(() => {
    return accounts.find((x) => x.id === item.arguments?.linkedinAccountId);
  }, [accounts, item.arguments?.linkedinAccountId]);

  // On liste les clés d'arguments qui peuvent contenir des liens
  const possibleUrlKeys = [
    "linkedinSalesNavigatorSearchUrl",
    "linkedinPeopleSearchUrl",
    "linkedInSearchUrl",
    "linkedinPostUrl",
    "linkedinJobSearchUrl",
    "linkedinCompanyUrl",
  ];

  // On détecte dynamiquement si l'une de ces clés existe et on récupère sa valeur
  const urlValue = useMemo(() => {
    if (!item?.arguments) return null;
    const key = possibleUrlKeys.find((k) => item.arguments[k]);
    return key ? item.arguments[key] : null;
  }, [item?.arguments]);

  const limitReached = useMemo(() => {
    let day = {
      used:
        getLimit("maxLinkedinInteractionsPerDay", profile, "value") -
        getLimit("maxLinkedinInteractionsPerDay", profile, "remaining"),
      limit: getLimit("maxLinkedinInteractionsPerDay", profile, "value"),
    };
    let month = {
      used:
        getLimit("maxLinkedinInteractionsPerMonth", profile, "value") -
        getLimit("maxLinkedinInteractionsPerMonth", profile, "remaining"),
      limit: getLimit("maxLinkedinInteractionsPerMonth", profile, "value"),
    };

    let reached_day = day.limit <= day.used && day.used !== 0;
    let reached_month = month.limit <= month.used && month.used !== 0;

    return {
      type: reached_day ? "day" : "month",
      isReached: reached_day || reached_month,
    };
  }, [profile]);

  return (
    <Stack gap={"xs"}>
      {limitReached?.isReached && !isCompleted && (
        <Text c={"red"} fw={600}>
          {limitReached?.type === "day"
            ? lang.contact_lists.jobs.completed.limit_reached_daily
            : lang.contact_lists.jobs.completed.limit_reached_monthly}
          <Link
            style={{ marginLeft: 6, fontWeight: 600 }}
            to={"/settings/subscription"}
          >
            {lang.contact_lists.jobs.completed.upgrade_account}
          </Link>
        </Text>
      )}

      {/* Rendu dynamique : on check si urlValue existe, puis si c'est un array */}
      {urlValue && (
        <Stack>
          <Group 
            wrap="nowrap" 
            align={Array.isArray(urlValue) ? "flex-start" : "center"} // Alignement au top si c'est une liste
          >
            <Text>{lang.contact_lists.jobs.completed.linkedin_links}</Text>
            
            {Array.isArray(urlValue) ? (
              // Si c'est un array, on map et on liste
              <Stack gap={4}>
                {urlValue.map((link, index) => (
                  <Anchor
                    key={index}
                    href={link || ""}
                    target="_blank"
                    fw={500}
                    fz={12}
                    truncate="end"
                    maw={450}
                  >
                    {link || ""}
                  </Anchor>
                ))}
              </Stack>
            ) : (
              // Si c'est un string, rendu classique
              <Anchor
                href={urlValue || ""}
                target="_blank"
                fw={500}
                fz={12}
                truncate="end"
                maw={450}
              >
                {urlValue || ""}
              </Anchor>
            )}
          </Group>
        </Stack>
      )}

      {item?.arguments?.linkedinAccountId && (
        <Group>
          <Text>
            {lang.contact_lists.jobs.completed.linkedin_account}{" "}
            <Anchor
              href={`/senders/linkedin/?highlight=${item?.arguments?.linkedinAccountId}`}
              target="_blank"
              fw={500}
              ml={8}
            >
              {account?.name || ""} #{item?.arguments?.linkedinAccountId}
            </Anchor>
          </Text>

          {account && !account?.is_valid && (
            <Text c={"red"} fw={600}>
              {lang.contact_lists.jobs.completed.not_valid_account}
            </Text>
          )}
        </Group>
      )}
      
      {item?.arguments?.maxResults && (
        <Text>
          {lang.contact_lists.jobs.completed.max_profiles}{" "}
          <b style={{ marginLeft: 8 }}>{item?.arguments?.maxResults}</b>
        </Text>
      )}
    </Stack>
  );
};

export default ArgumentsLinkedin;